import { Autocomplete, TextField, Tooltip } from "@mui/material";

import "./Notification.css";
import React, { useEffect, useState } from "react";
import { userDivisionType } from "../../components/userModal/userModalType";
import { getDivision } from "../../services/userService";
import {getDistinctFieldData, getImmediateParent,getUserList} from "../../services/notificationService";
import { notificationSearchParams, userTableMapping } from "./NotificationConfig";
import { DataGrid, GridColDef, GridColumnHeaderParams, GridRowId, GRID_CHECKBOX_SELECTION_COL_DEF, GridRowSelectionModel, GridOverlay } from "@mui/x-data-grid";
import { UserSelectionFilters } from "./notificationTypes";
import DefaultHeading from "../../components/heading/DefaultHeading";
import GenricMultiSelect from "../../components/Input/GenericMultiSelect";
import { useNavigate } from "react-router-dom";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { uniq } from "lodash";
import filterImage from '../../assets/images/png/filter.png'
import NotificationHistoryTable from "../../components/notificationHistoryTable/NotificationHistoryTable";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";


const Notification = () => {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const CUR_COMPONENT = "notification"
    const [divisionDataArray, setDivisionDataArray] = useState<userDivisionType[]>([]);
    const [reportingManager, setReportingManager] = useState<userDivisionType[]>();
    const [currentUserLevel, setCurrentUserLevel] = useState(0);
    const [immediateParentOptions, setImmediateParentOptions] = useState<any>([]);
    const [allUsers, setAllUsers] = useState<any[]>([]);
    const [rows, setRows] = useState<any[]>([]);
    const [userSelectionFilters, setUserSelectionFilters] = useState<UserSelectionFilters>({});
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [selectedIds, setSelectedIds] = useState<GridRowId[]>([]);
    const [searchField, setSearchField] = useState<string>("");
    const [outletClassOptions, setOutletClassOptions] = useState<string[]>([]);
    const [channelOptions, setChannelOptions] = useState<string[]>([]);
    const [filterSelected, setFilterSelected] = useState<boolean>(false)
    const navigate = useNavigate();
    
    const getDivisionsData = async () => {
        const response = await getDivision();
        setDivisionDataArray(response);
    };

    const getAndSetAdditionalFilterData = async ()=>{
        const outletClasses = await getDistinctFieldData("OutletDetails","outletClass");
        const channels = await getDistinctFieldData("OutletDetails","channel");
        setOutletClassOptions(outletClasses)
        setChannelOptions(channels)
    }

    useEffect(() => {
        getDivisionsData();
        getAndSetAdditionalFilterData();
    }, []);

    useEffect(() => {
        const reportingManager =  divisionDataArray.filter((item) => item.divisionLevel < currentUserLevel);
        setReportingManager(reportingManager);
    }, [currentUserLevel]);

    const handleDivisionSelection = (event:React.SyntheticEvent<Element, Event>, value: string) => {
        if(!filterSelected){
            setFilterSelected(true)
        }
        const currentDivisionObject = divisionDataArray.find(divisionObject=>value === divisionObject.divisionName);
        if(currentDivisionObject){
            const level = currentDivisionObject.divisionLevel;
            setCurrentUserLevel(level);
            setUserSelectionFilters({ 
                division: value
            });
        }
        if (value) {
            getUserTableInfo(value);
        }
    }
    

    const defaultFilter = (dataValue: string, searchedValue: string) => {
        if (!dataValue) {
            return;
        }
        dataValue = dataValue.toString();
        return dataValue.toLowerCase().includes(searchedValue.toLowerCase());
    };

    const filterUserData = (search: string) => {
        if (search) {
            const newData = allUsers.filter((user: any) => {
                const isPresent = notificationSearchParams.filter(
                    (searchParam) => {
                        return defaultFilter(user[searchParam], search);
                    }
                );
                if (isPresent.length !== 0) {
                    return true;
                } else {
                    return false;
                }
            });
            setRows(newData);
        } else {
            setRows(allUsers);
        }
    };

    const getUserTableInfo = async (designation: string, immediateParent?: string[], channel?: string[], outletClass?: string[], immediateRole?:string) => {
        setAllUsers([]);
        setRows([]);
        const immediateParentObjects = immediateParent ? immediateParentOptions.filter((data:any)=> immediateParent.includes(data.name)) : immediateParent;
        const immediateParentIds = immediateParentObjects ? immediateParentObjects.map((parentObject:any)=>designation === "retailer" ? parentObject.loginId : parentObject.immediateParent) : undefined;
        const response = await getUserList(designation,immediateParentIds,channel,outletClass, immediateRole);
        if (response.status === 200) {
            const userList = response?.data?.features;
            setAllUsers(userList);
            setRows(userList);
        }
    };

    const getImmediateParentList = async (designation: string) => {
        const response = await getImmediateParent(designation);
        setImmediateParentOptions(response.data.features);
    };

    let columns: GridColDef[] = userTableMapping.columns.map(
        (columnsMetaData) => {
            return {
                disableColumnMenu: true,
                field: columnsMetaData.mappedValue,
                headerName: columnsMetaData.headerName,
                sortable: false,
                minWidth: 100,
                flex: 1,
                headerAlign: "left",
                align: "left",
                renderHeader: (params: GridColumnHeaderParams) => (
                    <Tooltip title={columnsMetaData.headerName}>
                        <b>{translate(TranslationEnum.notification,columnsMetaData.headerName)}</b>
                    </Tooltip>
                ),
            };
        }
    );
    columns = [...columns, { ...GRID_CHECKBOX_SELECTION_COL_DEF, width: 100 }];
    

    const handleImmediateRoleChange = (event:React.SyntheticEvent<Element, Event>, value: string | null) => {
        if (value) {
            getImmediateParentList(value);
            setUserSelectionFilters({
                division: userSelectionFilters.division,
                immediateRole: value,
            });
            if (userSelectionFilters.division === "retailer") {
                getUserTableInfo(userSelectionFilters.division, userSelectionFilters.immediateParent, userSelectionFilters.channel, userSelectionFilters.outletClass, value);
            }
        }
    }
    

    const handleImmediateParentChange = (event:React.SyntheticEvent<Element, Event>, value: string | null) => {
        if (value) {
            setUserSelectionFilters({
                ...userSelectionFilters,
                immediateParent: [value],
            });
            if (userSelectionFilters.division) {
                getUserTableInfo(userSelectionFilters.division, [value], userSelectionFilters.channel, userSelectionFilters.outletClass, userSelectionFilters.immediateRole);
            }
        }
    }

    const handleMultipleImmediateParentChange = ( value: string[]) => {
        if (value) {
            setUserSelectionFilters({
                ...userSelectionFilters,
                immediateParent: value,
            });
            if (userSelectionFilters.division) {
                getUserTableInfo(userSelectionFilters.division, value, userSelectionFilters.channel, userSelectionFilters.outletClass, userSelectionFilters.immediateRole);
            }
        }
    }

    const handleOnRoleSelection = (newRowSelectionModel:GridRowSelectionModel) => {
        const selectedRowData = newRowSelectionModel.map((selectedId) =>
            rows.find((row) => row.id === selectedId)
        );
        setSelectedIds(newRowSelectionModel);
        setSelectedRows(selectedRowData);
    }

    const handleOnChannelSelection = (selectedOptions:string[]) => {
        getUserTableInfo("retailer",userSelectionFilters.immediateParent,selectedOptions,userSelectionFilters.outletClass,userSelectionFilters.immediateRole);
        setUserSelectionFilters({
            ...userSelectionFilters,
            channel: selectedOptions,
        });
    }

    const handleOnOutletClassSelection = (selectedOptions:string[]) => {
        getUserTableInfo("retailer",userSelectionFilters.immediateParent,userSelectionFilters.channel,selectedOptions,userSelectionFilters.immediateRole);
        setUserSelectionFilters({
            ...userSelectionFilters,
            outletClass: selectedOptions,
        });
    }
    const customNoRowsOverlay = () => (
        <GridOverlay>
          <div>{translate(TranslationEnum.common_portal,"No Rows")}</div>
        </GridOverlay>
      );

    return (
        <div className="notification-container">
            <DefaultHeading heading={translate(TranslationEnum.notification,"Push Notification")} showDefaultBackButton={true}>
                <>
                    <button
                        className="notification-next-button"
                        onClick={() => {
                            if(selectedRows.length){
                                navigate('send',{state:selectedRows})
                            }else{
                                openPopup("Alert","No User Selected")
                            }
                        }}
                    >
                        {translate(TranslationEnum.notification,"NEXT")}
                    </button>
                </>
            </DefaultHeading>
            <div className="notification-top-row-container">
                <div className="notification-user-selection-filter-container">
                    <Autocomplete
                        disablePortal
                        size="small"
                        className="notification-user-selection-filter"
                        disableClearable
                        sx={{ width: "20%" }}
                        value={userSelectionFilters.division}
                        onChange={handleDivisionSelection}
                        options={ divisionDataArray ? uniq(divisionDataArray.map((eachDivison: userDivisionType) => eachDivison.divisionName)): []}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={translate(TranslationEnum.notification,"Select Role")}
                            />
                        )}
                    />
                    <Autocomplete
                        disablePortal
                        size="small"
                        className="notification-user-selection-filter"
                        disableClearable
                        sx={{ width: "20%" }}
                        onChange={handleImmediateRoleChange}
                        value={ userSelectionFilters.immediateRole ?? "" }
                        options={ reportingManager ? reportingManager.map((eachManager) => eachManager.divisionName) : [] }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={translate(TranslationEnum.notification,"Select Immediate Role")}
                            />
                        )}
                    />
                    {userSelectionFilters.division === "retailer" &&
                        <GenricMultiSelect
                            className='notification-user-selection-filter'
                            label={translate(TranslationEnum.notification,"Select Immediate Parent")} 
                            options={immediateParentOptions.map((each:any) => each.name)}
                            selectedOptions={userSelectionFilters.immediateParent ?? []}
                            handleMultiSelectState = {handleMultipleImmediateParentChange}
                            isRequired = {false}
                            noOptionMessage = "No Data" 
                            params={{size:"small", disableClearable:false}}
                        />
                    }
                    {userSelectionFilters.division !== "retailer" &&
                        <Autocomplete
                            disablePortal
                            size="small"
                            className="notification-user-selection-filter"
                            disableClearable
                            sx={{ width: "20%" }}
                            value={ userSelectionFilters.immediateParent?.length ? userSelectionFilters.immediateParent[0]  : "" }
                            options={ immediateParentOptions.map((each:any) => each.name) }
                            onChange={handleImmediateParentChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={translate(TranslationEnum.notification,"Select Immediate Parent")} 
                                />
                            )}
                        />
                    }
                </div>
                <TextField
                    sx={{ width: "30%" }}
                    className="notification-search-bar-container"
                    id="outlined-start-adornment"
                    size="small"
                    value={searchField}
                    label={translate(TranslationEnum.common_portal,"Search")}
                    onChange={(event) => {
                        setSearchField(event.target.value);
                        filterUserData(event.target.value);
                    }}
                />

            </div>
            {userSelectionFilters && userSelectionFilters.division && userSelectionFilters.division === "retailer" &&
                <div className="notification-additional-filter-comtainer">
                    <GenricMultiSelect
                        className='notification-additional-filter'
                        label={translate(TranslationEnum.notification,"Select Channel")} 
                        options={channelOptions}
                        selectedOptions={userSelectionFilters.channel ?? []}
                        handleMultiSelectState = {handleOnChannelSelection}
                        isRequired = {false}
                        noOptionMessage = "No Data" 
                        params={{size:"small", disableClearable:false}}
                    />
                    <GenricMultiSelect
                        className='notification-additional-filter'
                        label={translate(TranslationEnum.notification,"Select VPO Name")}
                        options={outletClassOptions}
                        selectedOptions={userSelectionFilters.outletClass ?? []}
                        handleMultiSelectState = {handleOnOutletClassSelection}
                        isRequired = {false}
                        noOptionMessage = "No Data" 
                        params={{size:"small", disableClearable:false}}
                    />
                </div>
            }
            {filterSelected && <div className="user-list">
                <DataGrid
                    disableRowSelectionOnClick={true}
                    checkboxSelection
                    autoHeight
                    rowHeight={45}
                    onRowSelectionModelChange={handleOnRoleSelection}
                    rowSelectionModel={selectedIds}
                    columns={columns}
                    rows={rows}
                    initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 10,
                            },
                        },
                    }}
                    componentsProps={{
                        pagination: {
                          labelRowsPerPage: translate(TranslationEnum.common_portal,"Rows per page"),
                        },
                      }}
                      components={{
                        NoRowsOverlay: customNoRowsOverlay
                      }}
                    pageSizeOptions={[10,20,50,100]}
                />
            </div>}
            {!filterSelected &&
                <div className="filter-select-alert-container">
                    <img className="" alt="preview" src={filterImage} style={{width:"6rem"}}/>
                    <div>
                    {translate(TranslationEnum.notification,"Select filter to continue")}
                    </div>
                </div>
            }
            <NotificationHistoryTable />
        </div>
    );
};

export default Notification;
